<template>
  <tr class="profile-table__row">
    <td class="profile-table__cell profile-table__cell-registrations">
      <div class="profile-table__item">{{ habilitationCert }}</div>
    </td>
    <td class="profile-table__cell profile-table__cell-registrations">
      <div class="profile-table__item">
        {{ habilitationName }}
        <span class="badge-new" v-if="habilitation.new">{{$t('new')}}</span>
      </div>
    </td>

    <td class="profile-table__cell profile-table__cell-registrations">
      <div class="profile-table__item">{{ qualif }}</div>
    </td>
    <td class="profile-table__cell profile-table__cell-registrations">
      <div class="profile-table__item d-flex align-items-center">
        <span class="mr-1 icon icon-calendar"/>
        <span class="">
          {{ formatDateDlv( habilitation.issueDate, 'DD.MM.YYYY' ) }}
        </span>
      </div>
    </td>
    <td class="profile-table__cell profile-table__cell-registrations">
      <div class="profile-table__item d-flex align-items-center">
        <span class="mr-1 icon icon-arrow-right"/>
        <span class="">
          {{ formatDate( habilitation.dlv, 'DD.MM.YYYY' ) }}
        </span>
      </div>
    </td>

    <td class="profile-table__cell profile-table__cell-registrations">
      <div
          class="profile-table__item d-flex justify-content-center align-items-center"
      >
        <div class="d-flex">
          <span class="mr-1" :class="ext ? 'icon-check' : ''"/>
        </div>
      </div>
    </td>
    <td class="profile-table__cell profile-table__cell-registrations">
      <div
          class="profile-table__item d-flex justify-content-center align-items-center"
      >
        <div class="d-flex">
          <span class="mr-1" :class="iata ? 'icon-check' : ''"/>
        </div>
      </div>
    </td>
    <td class="profile-table__cell profile-table__cell-registrations">
      <div class="profile-table__item d-flex justify-content-center align-items-center">
        <habilitation-action
            :habilitation="habilitation"
        />
      </div>
    </td>
  </tr>
</template>

<script>

import { mapFields } from 'vuex-map-fields';
import HabilitationAction from "./HabilitationAction";

export default {
  name: 'HabilitationRow',
  props: [ 'habilitation', 'index', 'isLast'],
  components: {
    HabilitationAction
  },
  data() {
    return {};
  },
  computed: {
    ...mapFields( [ 'user' ] ),
    ...mapFields( [ 'habilitations.habilitations' ] ),
    habilitationName() {
      let firstname = this.$lodash.get(
          this.habilitation,
          'traineeFirstname',
          ''
      );
      let lastname = this.$lodash.get( this.habilitation, 'traineeLastname', '' );
      return lastname + ' ' + firstname
    },
    habilitationCert() {
      return this.$lodash.get( this.habilitation, 'certificateNumber', '--' );
    },
    qualif() {
      let tl = this.$lodash.get( this.habilitation, 'habilitationTitle', '--' );
      if ( tl != null ) {
        return tl;
      } else return '--';
    },
    ext() {
      let isExtern = this.$lodash.get( this.habilitation, 'is_extern', false );
      if ( isExtern ) {
        return true;
      } else return false;
    },
    iata() {
      let isIata = this.$lodash.get( this.habilitation, 'is_iata', false );
      if ( isIata ) {
        return true;
      } else return false;
    },
    certificate() {
      return this.$lodash.get( this.habilitation, 'certificate', false );
    }
  },
  methods: {
    downloadCertificate() {
      let fileURL = this.certificate;
      let fileLink = document.createElement( 'a' );
      fileLink.href = fileURL;
      fileLink.setAttribute( 'download', 'certificate' );
      document.body.appendChild( fileLink );
      fileLink.click();
      fileLink.remove();
    },
    formatDate( date, format = 'YYYY.MM.DD' ) {
      if ( date && this.$moment( date ).isValid() ) {
        return this.$moment( date ).format( format );
      } else return '--';
    },
    formatDateDlv( date, format = 'YYYY.MM.DD' ) {
      if ( date && this.$moment( date ).isValid() ) {
        return this.$moment( date ).format( format );
      } else return $t( 'noLimit' );
    }
  }
};
</script>

<style lang="scss" scoped>
.badge-new {
  padding: 0px 7px;
  font-size: 0.6rem;
  border-radius: 11px;
  background-color: #e1f1ff;
  color: #0082fa;
  text-transform: uppercase;
}
</style>
